import React from "react";
import Query from "../Query";
import Gallery from "./gallery";
import UBERUNS_SLIDER_QUERY from "../../queries/ue-ber-uns/slider";

const AboutSliderSection = () => {
  return (
    <Query query={UBERUNS_SLIDER_QUERY}>
      {({ data: { aboutUs } }) => {
        const slider = aboutUs?.data?.attributes?.slider;

        if (!slider) return null;

        return <Gallery items={slider}></Gallery>;
      }}
    </Query>
  );
};

export default AboutSliderSection;
